import { render, staticRenderFns } from "./EnvoiJument.vue?vue&type=template&id=060af974&"
import script from "./EnvoiJument.vue?vue&type=script&lang=js&"
export * from "./EnvoiJument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports